/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { filterBy } from '@ember/object/computed';
import Component from '@ember/component';
import { TYPES } from 'cio/utils/ad-audiences';

@tagName('')
export default class AdAudienceUsage extends Component {
  @service analytics;

  // external
  audiences = null;

  segment = null;

  // internal
  @filterBy('audiences', 'type', TYPES.adwords) _googleAdAudiences;

  @filterBy('audiences', 'type', TYPES.facebook) _facebookAdAudiences;

  @action
  didClickAddAudience() {
    this.analytics.track('audience', 'sync_creation_started', { model: this.segment });
  }
}
